export default "__VITE_ASSET__C0ZZc25C__"